import { Utility } from '../utility/utility_controller'

var $grids
var mouseClientX = 0
var mouseClientY = 0
var hasMousePosition = false
var dimRowsHoverRaf = null
var dimRowsLastTargetByGrid = new WeakMap()

var onResize = function () {
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			setColOrderAndLastClass($el, config)
			setCSS($el, config)
		})
	}
}

var isAuto = function (myString) {
	return isNaN(Number(myString)) || myString.trim() === ''
}

var dimRowsOnHoverIsEnabled = function (config) {
	return config && (config.dimRowsOnHover === true || config.dimRowsOnHover === 'true' || config.dimRowsOnHover === '1')
}

var dimRowsTransitionIsEnabled = function (config) {
	return config && (config.dimRowsTransition === true || config.dimRowsTransition === 'true' || config.dimRowsTransition === '1')
}

var dimRowsTransitionOnRowChangeIsEnabled = function (config) {
	return config && (config.dimRowsTransitionOnRowChange === true || config.dimRowsTransitionOnRowChange === 'true' || config.dimRowsTransitionOnRowChange === '1')
}

var mouseoverStyleIsEnabled = function (config) {
	return config && (config.doHoverColor === true || config.doHoverColor === 'true' || config.doHoverColor === '1' || config.doBgHoverColor === true || config.doBgHoverColor === 'true' || config.doBgHoverColor === '1')
}

// The dim-opacity transition should only run when the mouse enters or leaves the grid,
// unless the row-change transition is enabled separately.
var updateDimTransitionClass = function (grid, config, newTarget) {
	var prevTarget = dimRowsLastTargetByGrid.get(grid) || null
	var isEnterOrLeave = (!prevTarget && newTarget) || (prevTarget && !newTarget)
	var isTargetChange = prevTarget && newTarget && prevTarget !== newTarget
	if (dimRowsTransitionIsEnabled(config) && isEnterOrLeave) {
		grid.classList.add('lay-projectindex-dim-transition-active')
	} else if (!dimRowsTransitionIsEnabled(config) || isTargetChange) {
		grid.classList.remove('lay-projectindex-dim-transition-active')
	}
	if (dimRowsTransitionOnRowChangeIsEnabled(config) && isTargetChange) {
		grid.classList.add('lay-projectindex-dim-row-change-transition-active')
	} else if (!dimRowsTransitionOnRowChangeIsEnabled(config) || isEnterOrLeave) {
		grid.classList.remove('lay-projectindex-dim-row-change-transition-active')
	}
}

var clearDimRowsHoverForGrid = function (grid) {
	if (!grid) {
		return
	}
	grid.classList.remove('lay-projectindex-row-hover-active')
	grid.querySelectorAll('.lay-projectindex-row.hover').forEach(function (row) {
		row.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-row.lay-projectindex-dim-row-hover').forEach(function (row) {
		row.classList.remove('lay-projectindex-dim-row-hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter.hover').forEach(function (filter) {
		filter.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.hover').forEach(function (filterWrap) {
		filterWrap.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.lay-projectindex-dim-row-hover').forEach(function (filterWrap) {
		filterWrap.classList.remove('lay-projectindex-dim-row-hover')
	})
}

var setDimRowsHoverRow = function (grid, row, config) {
	if (!grid || !row) {
		return
	}
	grid.querySelectorAll('.lay-projectindex-filter.hover').forEach(function (filter) {
		filter.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.hover').forEach(function (filterWrap) {
		filterWrap.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.lay-projectindex-dim-row-hover').forEach(function (filterWrap) {
		filterWrap.classList.remove('lay-projectindex-dim-row-hover')
	})
	grid.querySelectorAll('.lay-projectindex-row.hover').forEach(function (hoverRow) {
		if (hoverRow !== row) {
			hoverRow.classList.remove('hover')
		}
	})
	grid.querySelectorAll('.lay-projectindex-row.lay-projectindex-dim-row-hover').forEach(function (hoverRow) {
		if (hoverRow !== row) {
			hoverRow.classList.remove('lay-projectindex-dim-row-hover')
		}
	})
	if (mouseoverStyleIsEnabled(config)) {
		row.classList.add('hover')
	} else {
		row.classList.remove('hover')
	}
	row.classList.add('lay-projectindex-dim-row-hover')
	grid.classList.add('lay-projectindex-row-hover-active')
}

var setDimRowsHoverFilterWrap = function (grid, filterWrap, config) {
	if (!grid || !filterWrap) {
		return
	}
	grid.querySelectorAll('.lay-projectindex-row.hover').forEach(function (row) {
		row.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-row.lay-projectindex-dim-row-hover').forEach(function (row) {
		row.classList.remove('lay-projectindex-dim-row-hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter.hover').forEach(function (hoverFilter) {
		hoverFilter.classList.remove('hover')
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.hover').forEach(function (hoverFilterWrap) {
		if (hoverFilterWrap !== filterWrap) {
			hoverFilterWrap.classList.remove('hover')
		}
	})
	grid.querySelectorAll('.lay-projectindex-filter-wrap.lay-projectindex-dim-row-hover').forEach(function (hoverFilterWrap) {
		if (hoverFilterWrap !== filterWrap) {
			hoverFilterWrap.classList.remove('lay-projectindex-dim-row-hover')
		}
	})
	if (mouseoverStyleIsEnabled(config)) {
		filterWrap.classList.add('hover')
	} else {
		filterWrap.classList.remove('hover')
	}
	filterWrap.classList.add('lay-projectindex-dim-row-hover')
	grid.classList.add('lay-projectindex-row-hover-active')
}

var updateDimRowsHover = function () {
	dimRowsHoverRaf = null
	if (!hasMousePosition || typeof $grids == 'undefined') {
		return
	}

	var elementAtPoint = document.elementFromPoint(mouseClientX, mouseClientY)
	var activeRow = elementAtPoint && elementAtPoint.closest ? elementAtPoint.closest('.lay-projectindex-dim-rows-on-hover .lay-projectindex-row') : null
	var activeFilterWrap = !activeRow && elementAtPoint && elementAtPoint.closest ? elementAtPoint.closest('.lay-projectindex-dim-rows-on-hover .lay-projectindex-filter-wrap') : null
	var activeGrid = activeRow && activeRow.closest ? activeRow.closest('.lay-projectindex-dim-rows-on-hover') : null
	if (!activeGrid && activeFilterWrap && activeFilterWrap.closest) {
		activeGrid = activeFilterWrap.closest('.lay-projectindex-dim-rows-on-hover')
	}

	$grids.each(function () {
		var grid = this
		var config = jQuery(grid).data('config')
		if (!dimRowsOnHoverIsEnabled(config)) {
			updateDimTransitionClass(grid, config, null)
			clearDimRowsHoverForGrid(grid)
			dimRowsLastTargetByGrid.set(grid, null)
			return
		}
		var newTarget = grid === activeGrid ? activeRow || activeFilterWrap || null : null
		updateDimTransitionClass(grid, config, newTarget)
		if (newTarget && activeRow) {
			setDimRowsHoverRow(grid, activeRow, config)
		} else if (newTarget && activeFilterWrap) {
			setDimRowsHoverFilterWrap(grid, activeFilterWrap, config)
		} else {
			clearDimRowsHoverForGrid(grid)
		}
		dimRowsLastTargetByGrid.set(grid, newTarget)
	})
}

var scheduleDimRowsHoverUpdate = function () {
	if (dimRowsHoverRaf != null) {
		return
	}
	dimRowsHoverRaf = window.requestAnimationFrame(updateDimRowsHover)
}

var bindDimRowsHoverForGrid = function ($grid, config) {
	$grid.off('mouseenter.layProjectIndexDimRows mouseleave.layProjectIndexDimRows')
	if (!dimRowsOnHoverIsEnabled(config)) {
		clearDimRowsHoverForGrid($grid[0])
		return
	}
	$grid.on('mouseenter.layProjectIndexDimRows', scheduleDimRowsHoverUpdate)
	$grid.on('mouseleave.layProjectIndexDimRows', function () {
		updateDimTransitionClass(this, jQuery(this).data('config'), null)
		clearDimRowsHoverForGrid(this)
		dimRowsLastTargetByGrid.set(this, null)
	})
}

var bindDimRowsGlobalEvents = function () {
	jQuery(document)
		.off('mousemove.layProjectIndexDimRows')
		.on('mousemove.layProjectIndexDimRows', function (event) {
			mouseClientX = event.clientX
			mouseClientY = event.clientY
			hasMousePosition = true
			scheduleDimRowsHoverUpdate()
		})

	if (window.eventsChannel && window.eventsChannel.off && window.eventsChannel.on) {
		window.eventsChannel.off('scroll', scheduleDimRowsHoverUpdate)
		window.eventsChannel.on('scroll', scheduleDimRowsHoverUpdate)
	}

	jQuery('.lay-overlay>.lay-content').off('scroll.layProjectIndexDimRows').on('scroll.layProjectIndexDimRows', scheduleDimRowsHoverUpdate)
}

var setColOrderAndLastClass = function ($el, config) {
	var sortedColumnsInConfig = config[Utility.screenSize].sortedColumns
	var target_order = []
	var target_visibles = []
	for (var index = 0; index < sortedColumnsInConfig.length; index++) {
		var element = sortedColumnsInConfig[index]

		target_order.push(element['name'])
		target_visibles.push(element['visible'])
	}

	// get values

	// sort rows and set "last visible class", row by row, because col could be empty, i set the one before as the last visible one
	// need this to hide correct separator for comma list type style

	// first order filter

	var orders = []
	var biggestVisibleOrderForRow = -1
	var biggestVisibleOrderForRowDomElementIx = -1
	$el.find('.lay-projectindex-filter').each(function (ix) {
		var order = 0
		if (this.classList.contains('lay-projectindex-filter-title')) {
			order = target_order.indexOf('title')
		} else if (this.classList.contains('lay-projectindex-filter-categories')) {
			order = target_order.indexOf('categories')
		} else if (this.classList.contains('lay-projectindex-filter-tags')) {
			order = target_order.indexOf('tags')
		} else if (this.classList.contains('lay-projectindex-filter-year')) {
			order = target_order.indexOf('year')
		}
		jQuery(this).css('order', order)

		if (order > biggestVisibleOrderForRow && target_visibles[order] == true) {
			biggestVisibleOrderForRow = order
			biggestVisibleOrderForRowDomElementIx = ix
		}
	})
	$el.find('.lay-projectindex-filter-wrap').find('.last-visible-projectindex-col').removeClass('last-visible-projectindex-col')
	if (biggestVisibleOrderForRowDomElementIx != -1) {
		$el.find('.lay-projectindex-filter:nth-child(' + (biggestVisibleOrderForRowDomElementIx + 1) + ')').addClass('last-visible-projectindex-col')
	}

	// order divs inside rows

	$el.find('.lay-projectindex-row').each(function () {
		var $row = jQuery(this)

		var biggestVisibleOrderForRow = -1
		var biggestVisibleOrderForRowDomElementIx = -1
		// orders = [];
		$row.find('>div').each(function (ix) {
			var order = 0
			switch (this.classList[0]) {
				case 'lay-projectindex-col-title':
					order = target_order.indexOf('title')
					break
				case 'lay-projectindex-col-categories':
					order = target_order.indexOf('categories')
					break
				case 'lay-projectindex-col-tags':
					order = target_order.indexOf('tags')
					break
				case 'lay-projectindex-col-year':
					order = target_order.indexOf('year')
					break
			}
			jQuery(this).css('order', order)
			// orders.push(order);
			if (order > biggestVisibleOrderForRow && target_visibles[order] == true && !this.classList.contains('lay-projectindex-col-empty')) {
				biggestVisibleOrderForRow = order
				biggestVisibleOrderForRowDomElementIx = ix
			}
		})

		$row.find('.last-visible-projectindex-col').removeClass('last-visible-projectindex-col')
		if (biggestVisibleOrderForRowDomElementIx != -1) {
			$row.find('>div:nth-child(' + (biggestVisibleOrderForRowDomElementIx + 1) + ')').addClass('last-visible-projectindex-col')
			// $row.find('.lay-projectindex-filter:nth-child('+(biggestVisibleOrderForRowDomElementIx+1)+')').addClass('last-visible-projectindex-col')
		}
	})
}

var setCSS = function ($el, config) {
	var $title = $el.find('.lay-projectindex-col-title, .lay-projectindex-filter-title')
	var $categories = $el.find('.lay-projectindex-col-categories, .lay-projectindex-filter-categories')
	var $tags = $el.find('.lay-projectindex-col-tags, .lay-projectindex-filter-tags')
	var $year = $el.find('.lay-projectindex-col-year, .lay-projectindex-filter-year')

	var style = typeof config.style == 'undefined' ? 'table' : config.style

	// we say width is "auto" if width is anything other than a number
	var tagsWidthIsAuto = isAuto(config[Utility.screenSize].tagsWidth)
	var categoriesWidthIsAuto = isAuto(config[Utility.screenSize].categoriesWidth)

	var titleWidthIsAuto = isAuto(config[Utility.screenSize].titleWidth)

	var yearWidthIsAuto = isAuto(config[Utility.screenSize].yearWidth)

	var titleVisible, categoriesVisible, tagsVisible, yearVisible

	for (var index = 0; index < config[Utility.screenSize].sortedColumns.length; index++) {
		var col = config[Utility.screenSize].sortedColumns[index]
		switch (col.name) {
			case 'title':
				titleVisible = col.visible
				break
			case 'categories':
				categoriesVisible = col.visible
				break
			case 'year':
				yearVisible = col.visible
				break
			case 'tags':
				tagsVisible = col.visible
				break
		}
	}

	var visibleCols = []
	for (var index = 0; index < config[Utility.screenSize].sortedColumns.length; index++) {
		var col = config[Utility.screenSize].sortedColumns[index]
		if (col.visible === true) {
			visibleCols.push(col)
		}
	}

	// when a col width is auto, the remaining width ( 100 - custom widths ) is split evenly between the auto widths
	// so first we need to calculate the "widthToSplitEvenly", then we can calculate the auto width per auto col
	var widthToSplitEvenly = 100
	var titleWidth, categoriesWidth, tagsWidth, yearWidth
	var visibleColumnsAmount = visibleCols.length
	var autoWidthColumnsAmount = visibleColumnsAmount

	// calculate widthToSplitEvenly
	for (var index = 0; index < visibleCols.length; index++) {
		var col = visibleCols[index]
		switch (col.name) {
			case 'title':
				if (!titleWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].titleWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'categories':
				if (!categoriesWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].categoriesWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'tags':
				if (!tagsWidthIsAuto) {
					widthToSplitEvenly -= Number(config[Utility.screenSize].tagsWidth)
					autoWidthColumnsAmount--
				}
				break
			case 'year':
				if (yearWidthIsAuto) {
					// if year width is auto give it a 15% width
					// thats just my design decision
					yearWidth = 15
					widthToSplitEvenly -= yearWidth
					autoWidthColumnsAmount--
				} else {
					widthToSplitEvenly -= Number(config[Utility.screenSize].yearWidth)
					autoWidthColumnsAmount--
				}
				break
		}
	}

	for (var index = 0; index < visibleCols.length; index++) {
		var col = visibleCols[index]
		switch (col.name) {
			case 'title':
				if (titleWidthIsAuto) {
					titleWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					titleWidth = config[Utility.screenSize].titleWidth
				}
				break
			case 'categories':
				if (categoriesWidthIsAuto) {
					categoriesWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					categoriesWidth = config[Utility.screenSize].categoriesWidth
				}
				break
			case 'tags':
				if (tagsWidthIsAuto) {
					tagsWidth = widthToSplitEvenly / autoWidthColumnsAmount
				} else {
					tagsWidth = config[Utility.screenSize].tagsWidth
				}
				break
			case 'year':
				if (yearWidthIsAuto) {
					// if year width is auto give it a 15% width
					// thats just my design decision
					yearWidth = 15
				} else {
					yearWidth = config[Utility.screenSize].yearWidth
				}
				break
		}
	}

	// set css
	if (tagsVisible) {
		$tags.show()
		if (style == 'table') {
			$tags.css('width', tagsWidth + '%')
		}
	} else {
		$tags.hide()
	}

	if (categoriesVisible) {
		$categories.show()
		if (style == 'table') {
			$categories.css('width', categoriesWidth + '%')
		}
	} else {
		$categories.hide()
	}

	if (yearVisible) {
		$year.show()
		if (style == 'table') {
			$year.css('width', yearWidth + '%')
		}
	} else {
		$year.hide()
	}

	if (titleVisible) {
		$title.show()
		if (style == 'table') {
			$title.css('width', titleWidth + '%')
		}
	} else {
		$title.hide()
	}
}

var bindFilterClick = function ($grid, config) {
	$grid.find('.lay-projectindex-filter-inner').off('click')
	$grid.find('.lay-projectindex-filter-inner').on('click', function () {
		var $filterButton = jQuery(this.parentNode)
		var $projectIndex = jQuery(this).closest('.lay-projectindex')
		var $rows = $projectIndex.find('.lay-projectindex-row')
		var order = 'DESC'

		if ($filterButton.hasClass('projectindex-filter-active')) {
			if ($filterButton.hasClass('order-ASC')) {
				$filterButton.removeClass('order-ASC').addClass('order-DESC')
				order = 'DESC'
			} else {
				$filterButton.removeClass('order-DESC').addClass('order-ASC')
				order = 'ASC'
			}
		} else {
			$projectIndex.find('.projectindex-filter-active').removeClass('projectindex-filter-active')
			if ($filterButton.hasClass('lay-projectindex-filter-year')) {
				$filterButton.removeClass('order-ASC').addClass('projectindex-filter-active order-DESC')
				order = 'DESC'
			} else {
				$filterButton.removeClass('order-DESC').addClass('projectindex-filter-active order-ASC')
				order = 'ASC'
			}
		}
		var orderby = ''
		if ($filterButton.hasClass('lay-projectindex-filter-title')) {
			orderby = 'title'
		} else if ($filterButton.hasClass('lay-projectindex-filter-categories')) {
			orderby = 'categories'
		} else if ($filterButton.hasClass('lay-projectindex-filter-tags')) {
			orderby = 'tags'
		} else if ($filterButton.hasClass('lay-projectindex-filter-year')) {
			orderby = 'date'
		}

		var array = []
		$rows.each(function (ix) {
			switch (orderby) {
				case 'title':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-projectindex-col-title').text(),
					})
					break
				case 'categories':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-projectindex-col-categories').text(),
					})
					break
				case 'tags':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-projectindex-col-tags').text(),
					})
					break
				case 'date':
					array.push({
						domIx: ix,
						text: jQuery(this).find('.lay-projectindex-col-year').attr('data-date'),
					})
					break
			}
		})

		// sort
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
		switch (orderby) {
			case 'title':
			case 'categories':
				array.sort((a, b) => a.text.localeCompare(b.text))
				break
			case 'tags':
				// natural sort in case someone uses numbers for tags
				// https://stackoverflow.com/questions/2802341/javascript-natural-sort-of-alphanumerical-strings
				array.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
				break
			case 'date':
				array.sort(function (a, b) {
					var numberA = parseInt(a.text, 10) // ignore upper and lowercase
					var numberB = parseInt(b.text, 10) // ignore upper and lowercase
					return numberA - numberB
				})
				break
		}

		if (order == 'DESC') {
			array = array.reverse()
		}

		jQuery('.lay-projectindex-first-row').css('border-top', '')
		jQuery('.lay-projectindex-first-row').removeClass('lay-projectindex-first-row')
		for (var index = 0; index < array.length; index++) {
			var element = array[index]
			$rows.eq(element.domIx).css('order', index)
			if (index == 0) {
				$rows.eq(element.domIx).addClass('lay-projectindex-first-row')
			}
		}
		jQuery('.lay-projectindex-first-row').css('border-top', config.lineStrokeWidth + 'px solid ' + config.lineColor)
		window.laytheme.emit('projectindex_reordered')
	})
}

var i = function () {
	window.laytheme.on('sizechanged', onResize)
	bindDimRowsGlobalEvents()
	bindOnNewpageShown()
}

var bindOnNewpageShown = function () {
	window.laytheme.on('newpageshown', function () {
		$grids = jQuery('.lay-projectindex')

		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			setColOrderAndLastClass($el, config)
			setCSS($el, config)
			bindFilterClick($el, config)
			bindDimRowsHoverForGrid($el, config)
			this.classList.add('initialized')
		})

		// change active class, for when we use splitscreen layout and "Never change scrolling position when navigating"
		// because then this markup may not be switched out with the latest version!
		$grids.each(function () {
			var $el = jQuery(this)
			var idOfCurrentlyActiveProjectindexInElement = $el.find('.lay-project-index-current-project .projectindex-project-link').attr('data-id')
			var idOfCurrentlyShownProject = jQuery('body').attr('data-id')
			if (idOfCurrentlyShownProject != idOfCurrentlyActiveProjectindexInElement) {
				$el.find('.lay-project-index-current-project').removeClass('lay-project-index-current-project')
				$el.find('.projectindex-project-link[data-id="' + idOfCurrentlyShownProject + '"]')
					.closest('.lay-projectindex-row')
					.addClass('lay-project-index-current-project')
			}
		})
	})
}

var projectindex_controller = {
	i: i,
}

export default projectindex_controller
